module.exports = __webpack_public_path__ + "assets/images/play.5c47980897247816f2020527d9ec46e1.svg";